import { Button, Skeleton } from '@aulastack/ui'
import type { ReactNode } from 'react'
import { Link, Navigate, useLocation } from 'react-router'
import type { Sessao } from '../contrato'
import { ErroApi } from './lib/api'
import { useSessao } from './lib/consultas'

export function Carregando() {
  return (
    <div role="status" aria-label="Carregando" className="mx-auto max-w-[1200px] px-4 py-8 sm:px-6">
      <Skeleton className="h-40 w-full" />
      <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-4">
        {[0, 1, 2, 3].map((i) => (
          <Skeleton key={i} className="h-40" />
        ))}
      </div>
    </div>
  )
}

export function NaoEncontrado({ voltarPara = '/' }: { voltarPara?: string }) {
  return (
    <div className="grid min-h-[60dvh] place-items-center px-6 text-center">
      <div className="grid justify-items-center gap-3">
        <h1 className="titulo-1">Página não encontrada</h1>
        <p className="max-w-sm text-text-2">O endereço não existe ou você não tem acesso a ele.</p>
        <Button asChild variante="secundario">
          <Link to={voltarPara}>Voltar ao início</Link>
        </Button>
      </div>
    </div>
  )
}

export function FalhaAoCarregar({ tentarDeNovo }: { tentarDeNovo: () => void }) {
  return (
    <div role="alert" className="grid min-h-[40dvh] place-items-center px-6 text-center">
      <div className="grid justify-items-center gap-3">
        <h2 className="titulo-2">Não foi possível carregar</h2>
        <p className="max-w-sm text-text-2">Confira a conexão e tente de novo.</p>
        <Button variante="secundario" onClick={tentarDeNovo}>
          Tentar de novo
        </Button>
      </div>
    </div>
  )
}

/** Só passa com sessão; sem ela, vai para a entrada e volta depois para cá. */
export function ExigirSessao({ children }: { children: (sessao: Sessao) => ReactNode }) {
  const sessao = useSessao()
  const { pathname, search } = useLocation()
  if (sessao.isPending) return <Carregando />
  if (sessao.isError) {
    if (sessao.error instanceof ErroApi && sessao.error.status === 401) {
      return <Navigate to="/login" replace state={{ de: pathname + search }} />
    }
    return <FalhaAoCarregar tentarDeNovo={() => void sessao.refetch()} />
  }
  return <>{children(sessao.data)}</>
}

/** "13 de out. de 2026" */
export const dataCurta = (iso: string) =>
  new Date(iso).toLocaleDateString('pt-BR', { day: 'numeric', month: 'short', year: 'numeric' })
